webpackJsonp([89292970737564],{

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.dateStyle = exports.titleStyle = exports.categoryTitleStyle = exports.thumbnailStyle = exports.ctaStyle = exports.bodyStyle = exports.innerWrapperStyle = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _css;
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var innerWrapperStyle = /*#__PURE__*/exports.innerWrapperStyle = (0, _emotion.css)({
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '0 auto',
		position: 'relative'
	});
	
	var bodyStyle = exports.bodyStyle = (0, _emotion.cx)(_globalStyles.textBlockLarger, /*#__PURE__*/(0, _emotion.css)((_css = {
		maxWidth: '760px',
		img: {
			maxWidth: '100%'
		}
	}, _css['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		fontSize: '14px'
	}, _css)));
	
	var ctaStyle = /*#__PURE__*/exports.ctaStyle = (0, _emotion.css)({
		marginTop: '60px',
		'& > *': {
			marginTop: '30px'
		}
	});
	
	var thumbnailStyle = /*#__PURE__*/exports.thumbnailStyle = (0, _emotion.css)({
		marginBottom: '36px',
		'& img': {
			maxWidth: '100%'
		}
	});
	
	var categoryTitleStyle = exports.categoryTitleStyle = function categoryTitleStyle(color) {
		return (/*#__PURE__*/(0, _emotion.css)({
				fontSize: '22px',
				lineHeight: '26px',
				fontWeight: 300,
				color: color,
				marginTop: 0,
				marginBottom: '12px'
			})
		);
	};
	
	var titleStyle = exports.titleStyle = (0, _emotion.cx)(_globalStyles.headingLarge, /*#__PURE__*/(0, _emotion.css)({
		margin: '0 0 12px 0'
	}));
	
	var dateStyle = /*#__PURE__*/exports.dateStyle = (0, _emotion.css)(_extends({}, _globalStyles.museo500, {
		fontSize: '16px',
		lineHeight: '22px',
		margin: '0 0 36px 0'
	}));

/***/ }),

/***/ 1147:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _headerManager = __webpack_require__(31);
	
	var _fullWidthCTA = __webpack_require__(170);
	
	var _dateManager = __webpack_require__(62);
	
	var _detail = __webpack_require__(484);
	
	var _globalStyles = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Gatsby requires a specific export format on Templates.
	var NewsDetail = function (_React$PureComponent) {
		_inherits(NewsDetail, _React$PureComponent);
	
		function NewsDetail() {
			var _temp, _this, _ret;
	
			_classCallCheck(this, NewsDetail);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.componentDidMount = function () {
				_headerManager.HeaderManager.headerProperties = {};
			}, _this.convertVimeoURL = function (vimeo_url) {
				var replacement = '//player.vimeo.com/video/$1';
				return vimeo_url.replace(/(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g, replacement);
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		NewsDetail.prototype.render = function render() {
			var _this2 = this;
	
			var node = this.props.data.news.edges[0].node;
	
	
			return _react2.default.createElement(
				'section',
				null,
				_react2.default.createElement(
					_reactHelmet.Helmet,
					{ title: node.title },
					_react2.default.createElement('meta', { name: 'description', content: node.extract }),
					_react2.default.createElement('meta', { property: 'og:type', content: 'article' }),
					_react2.default.createElement('meta', { property: 'og:title', content: node.title }),
					_react2.default.createElement('meta', { property: 'og:description', content: node.extract }),
					node.fields && node.fields.thumbnail_image && node.fields.thumbnail_image.childImageSharp.resize.src && _react2.default.createElement('meta', { property: 'og:image', content: 'https://insideoutinstitute.org.au' + node.fields.thumbnail_image.childImageSharp.resize.src })
				),
				_react2.default.createElement(
					'div',
					{ className: _detail.innerWrapperStyle },
					_react2.default.createElement(
						'div',
						{ className: _globalStyles.detailSideBarLayout.wrapper },
						_react2.default.createElement(
							'div',
							{ className: _globalStyles.detailSideBarLayout.leftSide },
							_react2.default.createElement(
								'div',
								{ className: (0, _globalStyles.contentSection)('#fff') },
								node.fields && _react2.default.createElement(
									'div',
									{ className: _detail.thumbnailStyle },
									_react2.default.createElement('img', { src: node.fields.thumbnail_image.childImageSharp.resize.src })
								),
								_react2.default.createElement(
									'p',
									{ className: (0, _detail.categoryTitleStyle)(_globalStyles.grey) },
									node.type
								),
								_react2.default.createElement(
									'h1',
									{ className: _detail.titleStyle },
									node.title
								),
								_react2.default.createElement(
									'p',
									{ className: _detail.dateStyle },
									(0, _dateManager.format)(node.date)
								),
								_react2.default.createElement('div', { className: _detail.bodyStyle, dangerouslySetInnerHTML: { __html: node.body } }),
								_react2.default.createElement(
									'div',
									{ className: _detail.ctaStyle },
									node.attachments && node.attachments.map(function (attachment, index) {
										var href = attachment.file || attachment.url;
	
										if (attachment.vimeo_url) {
											return _react2.default.createElement('iframe', {
												key: index,
												src: _this2.convertVimeoURL(attachment.vimeo_url),
												width: '100%',
												height: '360',
												frameBorder: '0',
												webkitallowfullscreen: 'true',
												mozallowfullscreen: 'true',
												allowFullScreen: 'true'
											});
										} else if (href) {
											return _react2.default.createElement(
												_fullWidthCTA.FullWidthCTA,
												{ key: index, link: { href: href } },
												attachment.link_text || 'View press release'
											);
										}
									})
								)
							)
						)
					)
				)
			);
		};
	
		return NewsDetail;
	}(_react2.default.PureComponent);
	
	NewsDetail.propTypes = {
		data: _propTypes2.default.shape({
			news: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						id: _propTypes2.default.string.isRequired,
						title: _propTypes2.default.string.isRequired,
						body: _propTypes2.default.string.isRequired,
						date: _propTypes2.default.string.isRequired,
						fields: _propTypes2.default.shape({
							thumbnail_image: _propTypes2.default.shape({
								childImageSharp: _propTypes2.default.shape({
									resize: _propTypes2.default.shape({
										src: _propTypes2.default.string.isRequired
									}).isRequired
								}).isRequired
							}).isRequired
						}),
						attachments: _propTypes2.default.arrayOf(_propTypes2.default.shape({
							file: _propTypes2.default.string,
							link_text: _propTypes2.default.string,
							url: _propTypes2.default.string,
							vimeo_url: _propTypes2.default.string
						}))
					}).isRequired
				})).isRequired
			}).isRequired
		}).isRequired
	};
	exports.default = NewsDetail;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-news-and-events-news-detail-index-js-0d3861608ac75d31f9f7.js